<template>
    <div class="table-action-buttons">
        <i v-if="this.$can('update-organisations')" class="fa fa-clone fa-lg pointer" @click="duplicate" :title="uLang('app.duplicate_type', { type: lang('app.trajectory') })"></i>
        <i v-if="this.$can('update-trajectories')" class="fa fa-edit fa-lg pointer" @click="edit" :title="uLang('app.edit_type', { type: lang('app.trajectory') })"></i>
        <i v-if="this.$can('delete-trajectories')" class="fa fa-trash fa-lg pointer" @click="remove" :title="uLang('app.delete_type', { type: lang('app.trajectory') })"></i>
    </div>
</template>

<script>
    import DestroyAlert from '~/Swals/DestroyAlert'
    import SuccessAlert from '~/Swals/SuccessAlert'

    export default {
        name: 'actions',
        props: ['data', 'index'],


        methods: {
            remove() {
                new DestroyAlert({ entity: this.lang('app.trajectory') }).show().then(async () => {
                    this.destroy()
                });
            },

            edit() {
                this.$router.push({ name: 'admin.trajectory_projects.trajectories.edit', params: { projectId: this.data.trajectory_project_id, id: this.data.id }})
            },

            async destroy() {
                const { data } = await window.axios.delete(route('trajectory-projects.trajectories.destroy', {trajectory_project: this.data.trajectory_project_id, trajectory: this.data.id}));
                new SuccessAlert({title: this.data.name, text: this.uLang('app.entity_removed', { entity: this.lang('app.trajectory') })}).show();
                vue.$emit('reloadTable');
            },

            async duplicate() {
                let {data} = await window.axios.post(route('trajectory-projects.trajectories.duplicate', { trajectory_project: this.data.trajectory_project_id, trajectory: this.data.id }));

                this.$router.push({ name: 'admin.trajectory_projects.trajectories.edit', params: { projectId: this.data.trajectory_project_id, id: data.id }});
            },
        }
    }
</script>

<style lang="scss" scoped>
</style>